// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"500":"66b89edb","989":"4974cf9e"}[chunkId] + ".chunk.js";
};